import { TextField, Grid } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import StyledLoadingButton from './StyledLoadingButton';

/**
 * 이메일(아이디) 입력 폼
 * @tpyedef {Object} props
 * @param {string} initVerifyButtonText - 초기 인증 버튼 텍스트
 * @param {string} verifiedButtonText - 이메일 인증 성공시 텍스트
 * @param {function} onChange - value onChange fun
 * @param {boolean} isVerifiedEmail - 검증된 이메일인지
 * @param {boolean} isSendLoading - 이메일 인증중 인지
 * @param {function} onClick - 인증 버튼 클릭시 event
 * @param {string} labelText - placeholder(label) text
 * @returns
 */
function InputEmail({
  initVerifyButtonText,
  verifiedButtonText,
  labelText,
  onChange,
  isVerifiedEmail,
  isSendLoading,
  onClick,
}) {
  return (
    <Grid item xs={12} style={{ display: 'flex' }}>
      <TextField
        required
        autoFocus
        fullWidth
        type="email"
        id="email"
        name="email"
        label={labelText}
        onChange={onChange}
        style={{ minWidth: '294px' }}
        disabled={isVerifiedEmail}
      />
      <StyledLoadingButton
        onClick={onClick}
        endIcon={isVerifiedEmail ? <SendIcon /> : <></>}
        loading={isSendLoading}
        loadingPosition="end"
        variant="contained"
      >
        <span>{isVerifiedEmail ? verifiedButtonText : initVerifyButtonText}</span>
      </StyledLoadingButton>
    </Grid>
  );
}

export default InputEmail;
